
import { defineComponent, PropType } from 'vue'
import { MessageAddress } from '@/api'
import TextOmit from '@/components/displays/TextOmit.vue'
import { formatDateWithDay } from '@/services/date'

/**
 * 日程(候補日)選択グループ
 */
export default defineComponent({
  name: 'ScheduleStaffListGroup',
  components: {
    TextOmit,
  },
  props: {
    // 日付一覧
    dates: {
      type: Array as PropType<string[]>,
      required: true,
    },
    // 宛先一覧
    messageAddresses: {
      type: Array as PropType<MessageAddress[]>,
      required: true,
    },
  },
  setup() {
    return {
      formatDateWithDay,
    }
  },
})
